import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { shortDate } from "../../lib/format";
import { Sun, CloudSun, Cloud, CloudRain, CloudDrizzle, CloudLightning, CloudFog, Snowflake, ChevronRight, Droplets, Wind } from "lucide-react";

const pick = (lang, hi, en) => (lang === "English" ? en : hi);
const ICONS = { sun: Sun, "cloud-sun": CloudSun, cloud: Cloud, "cloud-rain": CloudRain, "cloud-rain-wind": CloudRain, "cloud-drizzle": CloudDrizzle, "cloud-lightning": CloudLightning, "cloud-fog": CloudFog, snowflake: Snowflake };
const Wi = ({ name, ...p }) => { const C = ICONS[name] || Cloud; return <C {...p} />; };
const DOW = { हिंदी: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"], English: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] };

export function WeeklyWeather({ weather, language, item }) {
  if (!weather?.daily?.length) return null;
  const cur = weather.current || {};
  const dow = DOW[language] || DOW["हिंदी"];
  return (
    <motion.div variants={item} className="agro-glass rounded-[22px] p-5" data-testid="weekly-weather-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <span className="h-11 w-11 rounded-2xl bg-sky-100 flex items-center justify-center shrink-0"><Wi name={cur.code?.icon} className="h-6 w-6 text-sky-600" /></span>
          <div>
            <p className="font-display font-bold text-[17px] text-[#173f1e] leading-none">{cur.temp != null ? `${Math.round(cur.temp)}°C` : "—"} · {pick(language, "7-दिन का मौसम", "7-Day Weather")}</p>
            <p className="text-[12px] text-[#6c7a67] mt-1 flex items-center gap-2">
              <span>{cur.code?.label}</span>
              <span className="flex items-center gap-0.5"><Droplets className="h-3 w-3" />{cur.humidity ?? "—"}%</span>
              <span className="flex items-center gap-0.5"><Wind className="h-3 w-3" />{cur.wind ?? "—"}</span>
            </p>
          </div>
        </div>
        <Link to="/weather" className="text-sm font-semibold text-[#2f7d33] flex items-center tap" data-testid="weather-see-all">{pick(language, "और", "More")}<ChevronRight className="h-4 w-4" /></Link>
      </div>
      <div className="grid grid-cols-4 sm:grid-cols-7 gap-2">
        {weather.daily.slice(0, 7).map((d, i) => {
          const wet = (d.rainProb || 0) >= 50;
          return (
            <div key={i} className={`rounded-2xl p-2.5 text-center border ${i === 0 ? "bg-[#173f1e] text-white border-transparent" : wet ? "bg-sky-50 border-sky-100" : "bg-white/60 border-black/5"}`} data-testid={`weather-day-${i}`}>
              <p className={`text-[11px] font-medium ${i === 0 ? "text-white/80" : "text-[#6c7a67]"}`}>{i === 0 ? pick(language, "आज", "Today") : dow[new Date(d.date).getDay()]}</p>
              <Wi name={d.code?.icon} className={`h-5 w-5 mx-auto my-1.5 ${i === 0 ? "text-[#f2c230]" : "text-sky-500"}`} />
              <p className={`text-sm font-bold tabular-nums ${i === 0 ? "text-white" : "text-[#173f1e]"}`}>{Math.round(d.max)}°</p>
              <p className={`text-[10px] tabular-nums ${i === 0 ? "text-white/60" : "text-[#9aa79a]"}`}>{Math.round(d.min)}°</p>
              <p className={`text-[10px] mt-0.5 ${i === 0 ? "text-sky-200" : "text-sky-500"}`}>💧{d.rainProb || 0}%</p>
            </div>
          );
        })}
      </div>
      {weather.source === "estimate" && (
        <p className="text-[10px] text-[#9aa79a] mt-2">{pick(language, "अनुमानित मौसम (लाइव सेवा थोड़ी देर में)", "Estimated forecast (live service resuming shortly)")}</p>
      )}
    </motion.div>
  );
}
